/**
 * V2 Services Entry Point for BackOffice
 * Simple direct access pattern like popex
 */

import { UserService } from './services/UserService';
import { BookingService } from './services/BookingService';
import { StatsService } from './services/StatsService';
import { RobotService } from './services/RobotService';
import { NotificationService } from './services/NotificationService';
import { LocationService } from './services/LocationService';
import { ChatService } from './services/ChatService';
import { SettingsService } from './services/SettingsService';
import { IntegrationsService } from './services/IntegrationsService';

// Direct service instances - simple singleton pattern
export const userService = new UserService();
export const bookingService = new BookingService();
export const statsService = new StatsService();
export const robotService = new RobotService();
export const notificationService = new NotificationService();
export const locationService = new LocationService();
export const chatService = new ChatService();
export const settingsService = new SettingsService();
export const integrationsService = new IntegrationsService();

// Export models and services for direct import
export * from './models/User.model';
export * from './models/Booking.model';
export * from './models/Stats.model';
export * from './models/Robot.model';
export * from './models/Notification.model';
export * from './models/Location.model';
export * from './models/Chat.model';
export * from './models/Settings.model';
export * from './models/Integrations.model';

export * from './services/UserService';
export * from './services/BookingService';
export * from './services/StatsService';
export * from './services/RobotService';
export * from './services/NotificationService';
export * from './services/LocationService';
export * from './services/ChatService';
export * from './services/SettingsService';
export * from './services/IntegrationsService';

export * from './db/FirestoreService';